"use client";
import { useEffect } from "react";

type Config = {
    isEligible?: boolean;
    successCallback: PositionCallback;
    errorCallback: PositionErrorCallback;
};

export const useGetUserPosition = ({
    isEligible = true,
    errorCallback,
    successCallback,
}: Config) => {
    useEffect(() => {
        if (isEligible) {
            navigator?.geolocation?.getCurrentPosition?.(successCallback, errorCallback);
        }
    }, [isEligible]);
};
